module.exports = __webpack_public_path__ + "img/soziales.65dee98a.jpg";